import { parseAsString, useQueryState } from 'nuqs';

export function useAddressBookListFilter() {
  const [search, setSearch] = useQueryState('search', parseAsString.withDefault(''));

  return {
    setSearch,
    search,
  };
}
